import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { createRoot } from 'react-dom/client';

import { ThemeContainer } from 'ui-widgets';
import RestrictedItemsModal from '../../../app/RestrictedItemsModal';

const RestrictedItemsModalWrapper = () => {
  return (
    <ThemeContainer>
      <IntlProvider>
        <ApolloProvider>
          <ProjectsCustomerProvider>
            <CustomerProvider>
              <RestrictedItemsModal />
            </CustomerProvider>
          </ProjectsCustomerProvider>
        </ApolloProvider>
      </IntlProvider>
    </ThemeContainer>
  );
};

const container = document.getElementById('restrictedItemsModal');
const root = createRoot(container!);
root.render(<RestrictedItemsModalWrapper />);
